import { DataGridPagination } from "@/sharedTypes";

function Pagination({
  pagination = {
    pageSize: 10,
    pageIndex: 1, // Adjusted default to match your data
    totalPages: 1,
    totalItems: 0, // Added totalItems for accurate calculation
  },
  onPageChange,
}: {
  pagination: DataGridPagination;
  onPageChange: (newPageIndex: number) => void;
}) {
  const { pageSize, pageIndex, totalPages, totalItems } = pagination;
  const startEntry = (pageIndex - 1) * pageSize + 1; // Adjusted for 1-based pageIndex
  const endEntry = Math.min(pageIndex * pageSize, totalItems); // Ensure endEntry doesn't exceed totalItems

  return (
    <div className="flex flex-col items-center">
      {/* Help text */}
      <span className="text-sm text-gray-700 dark:text-gray-400">
        Showing{" "}
        <span className="font-semibold text-gray-900 dark:text-white">
          {startEntry}
        </span>{" "}
        to{" "}
        <span className="font-semibold text-gray-900 dark:text-white">
          {endEntry}
        </span>{" "}
        of{" "}
        <span className="font-semibold text-gray-900 dark:text-white">
          {totalItems}
        </span>{" "}
        Entries
      </span>
      <div className="xs:mt-0 mt-2 inline-flex">
        {/* Buttons */}
        <button
          onClick={() => onPageChange(pageIndex - 1)}
          disabled={pageIndex === 1} // Adjusted for 1-based pageIndex
          className="flex h-8 items-center justify-center rounded-s bg-gray-800 px-3 text-sm font-medium text-white hover:bg-gray-900 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <svg
            className="me-2 h-3.5 w-3.5 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 5H1m0 0 4 4M1 5l4-4"
            />
          </svg>
          Prev
        </button>
        <button
          onClick={() => onPageChange(pageIndex + 1)}
          disabled={pageIndex === totalPages} // Adjusted for 1-based pageIndex
          className="flex h-8 items-center justify-center rounded-e border-0 border-s border-gray-700 bg-gray-800 px-3 text-sm font-medium text-white hover:bg-gray-900 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          Next
          <svg
            className="ms-2 h-3.5 w-3.5 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 5h12m0 0L9 1m4 4L9 9"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Pagination;
